import api from '../../api/axios';

// Legacy action types (keep for backward compatibility)
export const GET_PAYMENT_METHODS_REQUEST = 'GET_PAYMENT_METHODS_REQUEST';
export const GET_PAYMENT_METHODS_SUCCESS = 'GET_PAYMENT_METHODS_SUCCESS';
export const GET_PAYMENT_METHODS_FAILURE = 'GET_PAYMENT_METHODS_FAILURE';
export const GET_STRIPE_CONNECT_REQUEST = 'GET_STRIPE_CONNECT_REQUEST';
export const GET_STRIPE_CONNECT_SUCCESS = 'GET_STRIPE_CONNECT_SUCCESS';
export const GET_STRIPE_CONNECT_FAILURE = 'GET_STRIPE_CONNECT_FAILURE';

// New action types
export const FETCH_PAYMENT_METHODS_REQUEST = 'FETCH_PAYMENT_METHODS_REQUEST';
export const FETCH_PAYMENT_METHODS_SUCCESS = 'FETCH_PAYMENT_METHODS_SUCCESS';
export const FETCH_PAYMENT_METHODS_FAILURE = 'FETCH_PAYMENT_METHODS_FAILURE';

export const CREATE_CHECKOUT_SESSION_REQUEST = 'CREATE_CHECKOUT_SESSION_REQUEST';
export const CREATE_CHECKOUT_SESSION_SUCCESS = 'CREATE_CHECKOUT_SESSION_SUCCESS';
export const CREATE_CHECKOUT_SESSION_FAILURE = 'CREATE_CHECKOUT_SESSION_FAILURE';

export const fetchPaymentMethods = () => async (dispatch) => {
  dispatch({ type: FETCH_PAYMENT_METHODS_REQUEST });
  try {
    const response = await api.get('/payment-methods');
    
    if (response?.data?.success) {
      const data = response.data.data || {};
      const paymentMethods = data.paymentMethods || [];
      
      dispatch({
        type: FETCH_PAYMENT_METHODS_SUCCESS,
        payload: {
          paymentMethods,
          customerId: data.customerId
        }
      });
      return { success: true, data: paymentMethods };
    } else {
      throw new Error(response?.data?.message || 'Failed to fetch payment methods');
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch payment methods';
    dispatch({
      type: FETCH_PAYMENT_METHODS_FAILURE,
      error: errorMessage
    });
    return { success: false, error: errorMessage };
  }
};

export const createCheckoutSession = (requestData = {}) => async (dispatch) => {
  dispatch({ type: CREATE_CHECKOUT_SESSION_REQUEST });
  try {
    const response = await api.post('/payment-methods/checkout-session', requestData);
    
    if (response?.data?.success) {
      const data = response.data.data || {};
      
      dispatch({
        type: CREATE_CHECKOUT_SESSION_SUCCESS,
        payload: data
      });
      
      return { success: true, data };
    } else {
      throw new Error(response?.data?.message || 'Failed to create checkout session');
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to create checkout session';
    dispatch({
      type: CREATE_CHECKOUT_SESSION_FAILURE,
      error: errorMessage
    });
    return { success: false, error: errorMessage };
  }
};
